import { ApiService } from './api/api'
import { processParams } from '@/utils/params'

export default class SubgroupService {
	private apiService

	constructor() {
		this.apiService = new ApiService(true) // middleware
	}

	/**
	 * Upload a file
	 * @returns Promise
	 */
	updateStockId(code: string, data: FormData): Promise<any> {
		const encodedCode = encodeURIComponent(code)
		return this.apiService.post(`/subgroups/stockid/${encodedCode}`, data)
	}

	getAll(params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/subgroups`, { params: processParams(params) })
	}

	findManyByCodes(codes: string[]): Promise<any> {
		return this.apiService.post('/subgroups/find-many', { codes })
	}
}
